import { reactive } from "vue";

const ACTIVITY_TIMEOUT = 30_000;

// Track when the user is active on the page
// so that we can pause certain things (like notifications) when the user is afk

const activity = reactive({
    lastActivityAt: Date.now(),
    isActive: true,
});

function updateActivity () {
    const now = Date.now();
    if (now - activity.lastActivityAt > 1_000) {
        activity.lastActivityAt = now;

        if (! activity.isActive) {
            activity.isActive = true;
        }
    }
}

setInterval(() => {
    if (! activity.isActive) return;
    const now = Date.now();
    if (now - activity.lastActivityAt > ACTIVITY_TIMEOUT) {
        activity.isActive = false;
    }
}, 1_000);

// Add passive window mouse move listener to track activity
window.document.body.addEventListener('mousemove', updateActivity, { passive: true });
window.document.body.addEventListener('scroll', updateActivity, { passive: true });
window.document.body.addEventListener('touchmove', updateActivity, { passive: true });
window.document.body.addEventListener('touchstart', updateActivity, { passive: true });

export default activity;